import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-672fdf5f"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "scroll-y-content" };
var _hoisted_2 = { class: "transport-table" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, null, -1 /* HOISTED */); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("Attente")
    ])
], -1 /* HOISTED */); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("Durée")
    ])
], -1 /* HOISTED */); });
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1 /* HOISTED */); });
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("Nombre"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("de places")
    ])
], -1 /* HOISTED */); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("Trans-"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("mission")
    ])
], -1 /* HOISTED */); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("Assignation"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("humaine")
    ])
], -1 /* HOISTED */); });
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("Assignation"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("algorithme")
    ])
], -1 /* HOISTED */); });
var _hoisted_11 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_TransportRow = _resolveComponent("TransportRow");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _createElementVNode("th", null, [
                        _createElementVNode("span", null, [
                            _createTextVNode("Origine" + _toDisplayString(_ctx.CHAR.NNBSP) + "/", 1 /* TEXT */),
                            _hoisted_6,
                            _createTextVNode("Destination")
                        ])
                    ]),
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    (_ctx.isEditable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_11, _toDisplayString(_ctx.CHAR.NBSP), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ])
            ]),
            _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transports, function (transport) {
                    return (_openBlock(), _createBlock(_component_TransportRow, {
                        key: transport.id,
                        transport: transport,
                        "is-editable": _ctx.isEditable,
                        timestamp: _ctx.timestamp,
                        "onTransport:inspect": _ctx.onInspectTransport,
                        "onTeam:inspect": _ctx.onInspectTeam
                    }, null, 8 /* PROPS */, ["transport", "is-editable", "timestamp", "onTransport:inspect", "onTeam:inspect"]));
                }), 128 /* KEYED_FRAGMENT */))
            ])
        ])
    ]));
}
